import React from 'react';
import toast from 'react-hot-toast';
import { motion } from 'framer-motion'

const colorClass = (type) => {
    switch (type) {
        case 'info':
            return 'border-blue-400 text-blue-400';
        case 'success':
            return 'border-green-400 text-green-400';
        case 'error':
            return 'border-red-400 text-red-400';
        default:
            return 'border-gray-400 text-gray-400';
    }
}

export function MyAlert(type, message) {
    toast.custom((t) => (
            <motion.div initial={{ x: -200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -200, opacity: 0 }}
                transition={{ duration: 0.5 }} className={`${t.visible ? 'animate-enter' : 'animate-leave'} backdrop-blur-sm px-6 py-2 rounded-r-xl border-l-4 pointer-events-auto  ${colorClass(type)}`}>
                <div className={`font-bold uppercase`}>{type}</div>
                <div className="text-xs font-light text-white max-w-lg">{message}</div>
            </motion.div>
    ))
}


